import { useState } from "react";
import PropTypes from "prop-types";

import classes from "./stepButtons.module.css";

import { ArrowBackIcon, ArrowForwardIcon } from "src/components/icons/ArrowIcons";
import { CancelIcon, SaveIcon } from "src/components/icons/ActionIcons";
import { useSnackbar } from "src/context/SnackbarContext";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import MyDivider2 from "src/components/layout/MyDivider2";
import { StyledButton } from "src/components/styled/StyledButton";
import { Button } from "@mui/material";

const gStyles = {
  iconText: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
  },
};

export default function StepButtons(props) {
  const { openSnackbar } = useSnackbar();
  // onCloseKlik

  // onCancelKlik
  // onSaveKlik

  // onPrevKlik
  // onNextKlik

  // onAcceptKlik

  // onQuitKlik
  // const leftButtonStyle = classes.leftButton;
  const rightButtonStyle = classes.rightButton;
  const fullButtonStyle = classes.fullButton;
  const variant = "contained";
  const disabled = props.disabled || props.isLoading || false;
  const enableButtonAfterKlik = props.enableButtonAfterKlik || false;
  const rightButtonDisabled = disabled || props.rightButtonDisabled;
  const buttonColor = "secondary";
  const padding = props.withPadding ? 20 : 0;
  const buttonHeight = props.size === "small" ? "35px" : "70px";
  const noDivider = props.noDivider || false;
  const rightButtonText = props.rightButtonText ? props.rightButtonText : "TALLENNA";
  const leftButtonText = props.leftButtonText ? props.leftButtonText : "PERUUTA";
  const closeText = props.closeText ? props.closeText : "SULJE";
  const closeIcon = props.closeIcon;
  const isLoading = props.isLoading || false;

  const maxCharsNum = 65;
  // get the first 50 characters of the text
  const maxChars = (text, num) => (text.length > num ? text.substring(0, num) + "..." : text);

  const rightButtonAltText = props.rightButtonAltText
    ? maxChars(props.rightButtonAltText, maxCharsNum)
    : "";
  const leftButtonAltText = props.leftButtonAltText
    ? maxChars(props.leftButtonAltText, maxCharsNum)
    : "";
  const closeButtonAltText = props.mainButtonAltText
    ? maxChars(props.mainButtonAltText, maxCharsNum)
    : "";

  const [leftButtonWait, setLeftButtonWait] = useState(false);
  const [rightButtonWait, setRightButtonWait] = useState(false);
  const [fullButtonWait, setFullButtonWait] = useState(false);

  return (
    <div className="noPrint">
      {!noDivider && <MyDivider2 />}
      <div className={classes.div1}>
        <RenderButtons />
      </div>
    </div>
  );

  function RenderButtons() {
    const styles = {
      dynamicPadding: {
        paddingTop: padding,
        paddingLeft: padding,
        paddingRight: padding,
        display: "flex",
        justifyContent: "space-evenly",
        paddingBottom: "20px",
      },
    };

    return (
      <div style={styles.dynamicPadding}>
        <LeftButton />
        <CancelButton />
        <CloseButton />
        <SaveButton />
        <AcceptButton />
        <RightButton />
      </div>
    );

    function RightButton() {
      return (
        props.onRightButtonKlik !== undefined &&
        !props.hideRightButton && (
          <StyledButton
            disabled={rightButtonDisabled || rightButtonWait}
            className={rightButtonStyle}
            variant={variant}
            color={buttonColor}
            onClick={() => {
              setRightButtonWait(!enableButtonAfterKlik);
              props.onRightButtonKlik();
            }}
            sx={{ height: buttonHeight }}
            aria-label={rightButtonText}>
            {isLoading ? (
              <ProgressCirc />
            ) : (
              <div className="center">
                {rightButtonText}
                <ArrowForwardIcon />
              </div>
            )}
            {rightButtonAltText && <div className={classes.altText}>{rightButtonAltText}</div>}
          </StyledButton>
        )
      );
    }

    function AcceptButton() {
      return (
        props.onAcceptKlik !== undefined && (
          <StyledButton
            disabled={rightButtonDisabled || rightButtonWait}
            className={rightButtonStyle}
            variant={variant}
            color={buttonColor}
            onClick={() => {
              setRightButtonWait(!enableButtonAfterKlik);
              props.onAcceptKlik();
            }}
            sx={{ height: buttonHeight }}
            aria-label={rightButtonText}>
            {isLoading ? (
              <ProgressCirc />
            ) : (
              <div>{rightButtonText ? rightButtonText : "TALLENNA"}</div>
            )}

            {rightButtonAltText && <div className={classes.altText}>{rightButtonAltText}</div>}
          </StyledButton>
        )
      );
    }

    function SaveButton() {
      return (
        props.onSaveKlik !== undefined && (
          <StyledButton
            disabled={rightButtonDisabled || rightButtonWait}
            // className={rightButtonStyle}
            width="47%"
            variant="contained"
            // color={buttonColor}
            onClick={async () => {
              openSnackbar({
                open: true,
                message: "",
                title: "Tallennetaan",
                severity: "info",
              });
              setRightButtonWait(!enableButtonAfterKlik);
              const a = await props.onSaveKlik();
              let success = false;
              if (a === true || a?.success === true) success = true;

              if (!success) {
                console.trace("Failure", a);
                openSnackbar({
                  open: true,
                  message: a?.message + (a?.origin ? " (" + a?.origin + ")" : "") || "",
                  title: "Tallennus epäonnistui",
                  severity: "error",
                });
              } else {
                openSnackbar({
                  open: true,
                  message: a?.message || "",
                  title: "Tallennettu",
                  severity: "success",
                });
              }
            }}
            sx={{ height: buttonHeight }}
            aria-label={rightButtonText}>
            {isLoading ? (
              <ProgressCirc />
            ) : (
              <div style={gStyles.iconText}>
                <SaveIcon style={{ opacity: "0.8" }} />
                <div>{rightButtonText ? rightButtonText : "TALLENNA"}</div>
              </div>
            )}

            {rightButtonAltText && <div className={classes.altText}>{rightButtonAltText}</div>}
          </StyledButton>
        )
      );
    }

    function CloseButton() {
      return (
        props.onCloseKlik !== undefined && (
          <div style={{ width: "100%" }}>
            <StyledButton
              disabled={disabled || fullButtonWait}
              className={fullButtonStyle}
              variant={variant}
              color={buttonColor}
              onClick={() => {
                setFullButtonWait(!enableButtonAfterKlik);
                props.onCloseKlik();
              }}
              width="80%"
              sx={{ height: buttonHeight }}
              aria-label={closeText}>
              {isLoading ? (
                <ProgressCirc />
              ) : (
                <div style={{ display: "flex", gap: 6 }}>
                  <div style={{ opacity: "0.8" }}>{closeIcon}</div>
                  <div>{closeText}</div>
                </div>
              )}
              {closeButtonAltText && <div className={classes.altText}>{closeButtonAltText}</div>}
            </StyledButton>
          </div>
        )
      );
    }

    function CancelButton() {
      return (
        props.onCancelKlik !== undefined && (
          <>
            <StyledButton
              width="47%"
              disabled={leftButtonWait}
              // className={leftButtonStyle}
              variant={variant}
              // color={buttonColor}
              onClick={() => {
                setLeftButtonWait(!enableButtonAfterKlik);
                props.onCancelKlik();
              }}
              sx={{ height: buttonHeight }}
              aria-label={leftButtonText}>
              {isLoading ? (
                <ProgressCirc />
              ) : (
                <div style={gStyles.iconText}>
                  <CancelIcon />
                  <div>{leftButtonText}</div>
                </div>
              )}

              {leftButtonAltText && <div className={classes.altText}>{leftButtonAltText}</div>}
            </StyledButton>
          </>
        )
      );
    }

    function LeftButton() {
      return (
        props.onLeftButtonKlik !== undefined && (
          <>
            <StyledButton
              disabled={leftButtonWait}
              // className={leftButtonStyle}
              variant={variant}
              // color={buttonColor}
              onClick={() => {
                setLeftButtonWait(!enableButtonAfterKlik);
                props.onLeftButtonKlik();
              }}
              sx={{ height: buttonHeight }}
              aria-label={props.leftButtonText}>
              {isLoading ? (
                <ProgressCirc />
              ) : (
                <div className="center">
                  <ArrowBackIcon />
                  {props.leftButtonText}
                </div>
              )}
              {leftButtonAltText && <div className={classes.altText}>{leftButtonAltText}</div>}
            </StyledButton>
          </>
        )
      );
    }
  }
}

StepButtons.propTypes = {
  onCancelKlik: PropTypes.func,
  onSaveKlik: PropTypes.func,
  onCloseKlik: PropTypes.func,
  onAcceptKlik: PropTypes.func,
  onLeftButtonKlik: PropTypes.func,
  onRightButtonKlik: PropTypes.func,
  leftButtonText: PropTypes.string,
  rightButtonText: PropTypes.string,
  closeText: PropTypes.string,
  hideRightButton: PropTypes.bool,
  noDivider: PropTypes.bool,
  padding: PropTypes.string,
  buttonHeight: PropTypes.number,
  variant: PropTypes.string,
  enableButtonAfterKlik: PropTypes.bool,
  disabled: PropTypes.bool,
  rightButtonDisabled: PropTypes.bool,
  withPadding: PropTypes.bool,
  size: PropTypes.string,
  leftButtonAltText: PropTypes.string,
  rightButtonAltText: PropTypes.string,
  mainButtonAltText: PropTypes.string,
  closeIcon: PropTypes.object,
  isLoading: PropTypes.bool,
};
